import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import prettyJoiner from 'scoreboard/reports/common/filter/pretty-joiner'

const selectionLevels = {
	'this-organization': _.identity,
	'only-children': i18n.get.bind(i18n, 'report.metricComparisonReport.childrenOfOrg'),
	'only-descendants': i18n.get.bind(i18n, 'report.metricComparisonReport.descendantsOfOrg'),
	'organization-and-children': i18n.get.bind(i18n, 'report.metricComparisonReport.orgNameAndChildren'),
	'organization-and-descendants': i18n.get.bind(i18n, 'admin.groupsByOrganization.viewOrgWithDescendants')
}

const PrettyCompareScorecardItemsFilter = filter => {
	filter.valid = true
	let scorecards = []
	_.each(filter.includeDescendants, (includeDescendants, id) => {
		let label = filter.itemLabels[id]
		if (label) {
			if (includeDescendants) {
				scorecards.push(i18n.get('admin.groupsByOrganization.viewOrgWithDescendants', label))
			} else {
				scorecards.push(label)
			}
		} else {
			scorecards.push(i18n.get('common.deletedItem'))
		}
	})

	let orgs = []
	_.each(filter.organizationSelections, (level, orgId) => {
		let label = filter.orgLabels[orgId]
		if (label) {
			orgs.push(selectionLevels[level](label))
		} else {
			orgs.push(i18n.get('common.deletedItem'))
		}
	})

	return i18n.get('report.filter.pretty.compareScorecardItems', prettyJoiner(orgs),
		prettyJoiner(scorecards))
}

export default PrettyCompareScorecardItemsFilter
PrettyCompareScorecardItemsFilter.__filename__ = 'reports/wizard/filter-meta/pretty-compare-scorecard-items-filter.js'
